"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewCriterionData = exports.Criterion = exports.CriterionData = void 0;
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var CriterionData = /** @class */ (function () {
    function CriterionData(args) {
        this.pk = args.pk;
        this.handgrading_rubric = args.handgrading_rubric;
        this.last_modified = args.last_modified;
        this.short_description = args.short_description;
        this.long_description = args.long_description;
        this.points = args.points;
    }
    return CriterionData;
}());
exports.CriterionData = CriterionData;
var Criterion = /** @class */ (function (_super) {
    __extends(Criterion, _super);
    function Criterion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Criterion.subscribe = function (observer) {
        Criterion._subscribers.add(observer);
    };
    Criterion.unsubscribe = function (observer) {
        Criterion._subscribers.delete(observer);
    };
    Criterion.get_all_from_handgrading_rubric = function (handgrading_rubric_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/handgrading_rubrics/" + handgrading_rubric_pk + "/criteria/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (data) { return new Criterion(data); })];
                }
            });
        });
    };
    Criterion.get_by_pk = function (criterion_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/criteria/" + criterion_pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new Criterion(response.data)];
                }
            });
        });
    };
    Criterion.create = function (handgrading_rubric_pk, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/handgrading_rubrics/" + handgrading_rubric_pk + "/criteria/", data)];
                    case 1:
                        response = _a.sent();
                        result = new Criterion(response.data);
                        Criterion.notify_criterion_created(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Criterion.notify_criterion_created = function (criterion) {
        var e_1, _a;
        try {
            for (var _b = __values(Criterion._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_criterion_created(criterion);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Criterion.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/criteria/" + this.pk + "/", utils_1.filter_keys(this, Criterion.EDITABLE_FIELDS))];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        Criterion.notify_criterion_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    Criterion.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var last_modified, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        last_modified = this.last_modified;
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/criteria/" + this.pk + "/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        if (last_modified !== this.last_modified) {
                            Criterion.notify_criterion_changed(this);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Criterion.notify_criterion_changed = function (criterion) {
        var e_2, _a;
        try {
            for (var _b = __values(Criterion._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_criterion_changed(criterion);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Criterion.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().delete("/criteria/" + this.pk + "/")];
                    case 1:
                        _a.sent();
                        Criterion.notify_criterion_deleted(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    Criterion.notify_criterion_deleted = function (criterion) {
        var e_3, _a;
        try {
            for (var _b = __values(Criterion._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_criterion_deleted(criterion);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    Criterion.get_order = function (handgrading_rubric_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/handgrading_rubrics/" + handgrading_rubric_pk + "/criteria/order/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    Criterion.update_order = function (handgrading_rubric_pk, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().put("/handgrading_rubrics/" + handgrading_rubric_pk + "/criteria/order/", data)];
                    case 1:
                        response = _a.sent();
                        result = response.data;
                        Criterion.notify_criteria_order_updated(result, handgrading_rubric_pk);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Criterion.notify_criteria_order_updated = function (criterion_list, handgrading_rubric_pk) {
        var e_4, _a;
        try {
            for (var _b = __values(Criterion._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_criteria_order_changed(criterion_list, handgrading_rubric_pk);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    Criterion._subscribers = new Set();
    Criterion.EDITABLE_FIELDS = [
        'short_description',
        'long_description',
        'points',
    ];
    return Criterion;
}(CriterionData));
exports.Criterion = Criterion;
var NewCriterionData = /** @class */ (function () {
    function NewCriterionData(args) {
        this.short_description = args.short_description;
        this.long_description = args.long_description;
        this.points = args.points;
    }
    return NewCriterionData;
}());
exports.NewCriterionData = NewCriterionData;
//# sourceMappingURL=criterion.js.map